// extracted by mini-css-extract-plugin
module.exports = {"audioSection":"Audio_audioSection__3DHEP","audioDescription":"Audio_audioDescription__SlolG","audio":"Audio_audio__sPQeU"};